// containers
import ServiceTypeAndCapacityForm from "../../../../../containers/forms/generalBranchSettingsForms/ServiceTypeAndCapacity/ServiceTypeAndCapacity.form";

const ServiceTypeAndCapacity = ({ branchId }) => {
  return <ServiceTypeAndCapacityForm branchId={branchId} />;
};

export default ServiceTypeAndCapacity;
